import { alpha } from '@mui/material';
export function containedStyle(color) {
    return {
        backgroundColor: color.main,
        color: color.contrastText,
        '&:hover, &.Mui-focusVisible': {
            backgroundColor: color.dark,
        },
        '& .MuiButton-startIcon': {
            color: color.contrastText,
        },
        '& .MuiChip-avatar': {
            backgroundColor: color.dark,
            color: color.contrastText,
        },
    };
}
export function outlinedStyle(color) {
    return {
        color: color.main,
        border: `1px solid ${color.main}`,
        '&:hover, &.Mui-focusVisible': {
            border: `1px solid ${color.dark}`,
            backgroundColor: alpha(color.light, 0.1),
        },
    };
}
export function textStyle(color) {
    return {
        color: color.main,
        '&:hover, &.Mui-focusVisible': {
            backgroundColor: alpha(color.light, 0.3),
        },
    };
}
